import React, { memo } from "react";

function withPopupContent<T>(Component: React.ComponentType<T>) {
  return memo(function(props: any) {
    return <Component {...props} />;
  });
}

export default withPopupContent;
